<template>
  <div
    id="cards"
    style="background-color:white"
    v-show="!loaded"
    :style="{ 'pointer-events': !gesture ? 'auto' : 'none' }"
  >
    <img :src="isamnet" width="100%" @load="onLoad" />
    <div
      class="ucf-card-wrapper"
      :style="
        creative.offset_bottom_number
          ? `bottom:${-15 + creative.offset_bottom_number}${
              creative.offset_bottom_unit
            }`
          : ``
      "
    >
      <a class="closebutton" @click="close()"></a>
      <div class="ucf-card-container">
        <div
          v-for="(card, index) in creative.cards"
          :key="index"
          :class="['ucf-cards', `card-${index + 1}`]"
        >
          <a :href="card.landing_page" target="_blank">
            <img :src="card.image_url" @load="onLoad" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixPreview from "@/components/mixins/preview.js";
import mixMobile from "@/components/mixins/mobile.js";
export default {
  data() {
    return {
      loaded: this.creative.cards.length + 1,
    };
  },
  computed: {
    isamnet() {
      let domain = window.location.hostname;
      let isAmnet = "https://cdn.aralego.net/rich_media/assets";
      if (domain === "prism.amnet.tw") {
        isAmnet += "/amnet/cards-bg.png";
      } else {
        isAmnet += "/cards/bg.png";
      }
      return isAmnet;
    },
  },
  async mounted() {
    this.viewport();
    await this.$nextTick();
    this.intervalEvent = setInterval(this.move_right, 3000);
    this.left = () => this.handleGesture("left");
    this.right = () => this.handleGesture("right");
    const wrapper = document.querySelector(".ucf-card-wrapper");
    this.handleTouch(wrapper);
    this.handleAnimate(wrapper);
  },
  mixins: [mixPreview, mixMobile],
  methods: {
    handleGesture(gesture) {
      if (this.isAnimating) return;
      gesture === "left" ? this.move_left() : this.move_right();
      clearInterval(this.intervalEvent);
      this.intervalEvent = setInterval(this.move_right, 3000);
    },
    move_left() {
      var cards = document.querySelectorAll(".ucf-cards");
      var tmpCard = cards[0];

      document.querySelector(".ucf-card-container").appendChild(tmpCard);
      cards[0].classList.add("card-move-left");
      cards[1].className = "ucf-cards card-1";
      cards[2].className = "ucf-cards card-2";
      cards[3].className = "ucf-cards card-3";
      cards[1].addEventListener(
        "transitionend",
        () => {
          cards[0].className = "ucf-cards card-4";
        },
        { once: true }
      );
    },
    move_right() {
      var cards = document.querySelectorAll(".ucf-cards");
      var tmpCard = cards[0];

      document.querySelector(".ucf-card-container").appendChild(tmpCard);
      cards[0].classList.add("card-move-right");
      cards[1].className = "ucf-cards card-1";
      cards[2].className = "ucf-cards card-2";
      cards[3].className = "ucf-cards card-3";
      cards[1].addEventListener(
        "transitionend",
        () => {
          cards[0].className = "ucf-cards card-4";
        },
        { once: true }
      );
    },
  },
};
</script>

<style lang="sass" scoped>
.ucf-card-wrapper
    width: 100%
    height: 250px
    position: fixed
    bottom: -15px
    .closebutton
        cursor: pointer
        position: absolute
        display: block
        width: 32px
        height: 32px
        background-color: white
        background-position: 0 0
        background-image: url('https://cdn.aralego.net/rich_media/assets/close_btn.png')
        z-index: 50000
        top: -15px
        right: 5px
        background-size: contain
        border-radius: 16px
    .ucf-card-container
        margin: 0 auto
        width: 400px
        height: 225px
        position: relative
        .ucf-cards
            position: absolute
            border-radius: 12px
            -webkit-border-radius: 12px
            -moz-border-radius: 12px
            box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.3)
            -webkit-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.3)
            -moz-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.3)
            transition: left 0.7s ease, top 0.7s ease, width 0.7s ease, transform 0.7s ease
            -webkit-transition: left 0.7s ease, top 0.7s ease, width 0.7s ease, -webkit-transform 0.7s ease
            overflow: hidden
            img
                width: 100%
                cursor: pointer
        .card-1
            width: 80%
            height: 80%
            left: 6%
            top: 20%
            z-index: 1500
        .card-2
            width: 78%
            height: 78%
            left: 10%
            top: 20%
            transform: rotate(2deg)
            -webkit-transform: rotate(2deg)
            -moz-transform: rotate(2deg)
            z-index: 1400
        .card-3
            width: 75%
            height: 75%
            left: 15%
            top: 20%
            transform: rotate(4deg)
            -webkit-transform: rotate(4deg)
            -moz-transform: rotate(4deg)
            z-index: 1300
        .card-4
            width: 73%
            height: 73%
            left: 19%
            top: 20%
            transform: rotate(6deg)
            -webkit-transform: rotate(6deg)
            -moz-transform: rotate(6deg)
            z-index: 1200
        .card-move-left
            animation: card-move-to-left 0.7s
            -webkit-animation: card-move-to-left 0.7s
            transition: 0.7s ease-in
            -webkit-transition: 0.7s ease-in
        .card-move-right
            animation: card-move-to-right 0.7s
            -webkit-animation: card-move-to-right 0.7s
            transition: 0.7s ease-in
            -webkit-transition: 0.7s ease-in

@include keyframes(card-move-to-left)
    80%
        left: -120%
        z-index: 1500
    100%
        width: 73%
        height: 73%
        left: 19%
        top: 20%
        z-index: 1200
        transform: rotate(6deg)


@include keyframes(card-move-to-right)
    80%
        left: 120%
        z-index: 1500
    100%
        width: 73%
        height: 73%
        left: 19%
        top: 20%
        z-index: 1200
        transform: rotate(6deg)
</style>
